import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
// core components
import Header from "components/Header/Header.js";
import Footer from "components/SiteFooter/Footer.js";
import HeaderLinks from "components/SiteHeader/HeaderLinks.js";

import styles from "assets/jss/material-kit-react/views/landingPage.js";
// Sections for this page
import Map from "./Sections/Map.js";
import CultureAndHeritage from "./Sections/CultureAndHeritage.js";
import GeographyInfo from "./Sections/GeographyInfo.js";
import Staff from "./Sections/Staff.js";
import ProjectAndBudget from "./Sections/ProjectAndBudget.js";
import ContactInfo from "./Sections/ContactInfo.js";
import Info from "views/MainPage/Sections/Info.js";
import {info} from "views/Municipality/Sections/MunicipalityInfo.js";
import {district_info} from "views/MainPage/MainPage.js";
import Brand from "../Brand.js";
import Activities from "./Sections/Activities.js";
import MoreInformation from "./Sections/MoreInformation.js";
import Description from "./Sections/Description.js";
import DescriptionOffices from "./Sections/DescriptionOffices.js";
import DescriptionDistrict from "./Sections/DescriptionDistrict.js";
import OfficesList from "./Sections/OfficesList.js";
import WardList from "./Sections/WardList.js";
import Municipality from "views/MainPage/Sections/Municipality.js";

import placeholder from "assets/img/bhaktapur/placeholder_person.png";
import ddc_member1 from "assets/img/bhaktapur/member1.jpg";
import ddc_member2 from "assets/img/bhaktapur/member2.jpg";
import ddc_employee3 from "assets/img/bhaktapur/employee3.jpg";
import "./style.scss";

import { API_BASE_URL } from "views/api"
const dashboardRoutes = [];

const useStyles = makeStyles(styles);

const listing_priority = [
  // MEMBER_DESIGNATION
  'district_head',
  'district_deputy_head',
  'district_member',
  'mayor',
  'deputy_mayor',
  'ward_president',
  'municipality_executive_member',
  // EMPLOYEE_DESIGNATION
  'e_district_head',
  'e_district_head_adhikari',
  'rajpatrankit_first',
  'rajpatrankit_second',
  'rajpatrankit_third',
  'rajpatra_ankit_first',
  'rajpatra_ankit_second',
  'rajpatra_ankit_third',
  'uncategorised',
  'chief_administrative_officer',
  'tenth_level',
  'ninth_level',
  'eight_level',
  'seventh_level',
  'sixth_level',
  'fifth_level',
  'forth_level',
  // METHOD_OF_ELECTION
  'directly_elected',
  'not_directly_elected',
  'elected_from_parliament_directy',
  'elected_from_parliament_directy_1',
  'elected_from_parliament_directy_2',
  'elected_from_parliament_proportionally',
  'elected_from_parliament_assembly',
  'elected_from_state_directly',
  'elected_from_state_directly_1_a',
  'elected_from_state_directly_1_b',
  'elected_from_state_directly_2_a',
  'elected_from_state_directly_2_b',
  'elected_from_state_proportionally'
]

const priorityBasedSort = (dataList, attribute_name) => {
  let modifiedDataList = []
  const caughtIndex = []

  let idx1, idx2
  for (idx1 in listing_priority) {
    for (idx2 in dataList) {
      if (dataList[idx2][attribute_name] === listing_priority[idx1]) {
        modifiedDataList.push(dataList[idx2])
        caughtIndex.push(idx2)
      }
    }
  }

  for (idx2 in dataList) {
    if(!caughtIndex.includes(idx2)) {
      modifiedDataList.push(dataList[idx2])
    }
  }
  if (modifiedDataList.length === 0) {
    return undefined
  }
  return modifiedDataList
}

export const map_data = {
  bhaktapur_ddc: {
    title: 'नक्शा र संसाधन',
    description: 'जि स स भक्तपुर',
  },
  changunarayan_municipality: {
    title: 'नक्शा र संसाधन',
    description: 'चाँगुनारायण नगरपालिका',
  },
  bhaktapur_municipality: {
    title: 'नक्शा र संसाधन',
    description: 'भक्तपुर नगरपालिका',
  },
  madhyapur_thimi_municipality: {
    title: 'नक्शा र संसाधन',
    description: 'मध्यपुर थिमि नगरपालिका',
  },
  suryabinayak_municipality: {
    title: 'नक्शा र संसाधन',
    description: 'सूर्यविनायक नगरपालिका',
  },
}
export const member_data_map = {
  bhaktapur_ddc: {
    description: 'भक्तपुर जि.स.स.',
  },
  changunarayan_municipality: {
    description: 'चाँगुनारायण नगर कार्यपालिका',
  },
  bhaktapur_municipality: {
    description: 'भक्तपुर नगर कार्यपालिका',
  },
  madhyapur_thimi_municipality: {
    description: 'मध्यपुर थिमि नगर कार्यपालिका',
  },
  suryabinayak_municipality: {
    description: 'सूर्यविनायक नगर कार्यपालिका',
  },
}

const api = {
  bhaktapur_ddc: {
    link: `${API_BASE_URL}introduction/geographical-details/?administrative_unit=bhaktapur_district`,
  },
  changunarayan_municipality: {
    link: `${API_BASE_URL}introduction/geographical-details/?administrative_unit=changunarayan`,
  },
  bhaktapur_municipality: {
    link: `${API_BASE_URL}introduction/geographical-details/?administrative_unit=bhaktapur`,
  },
  madhyapur_thimi_municipality: {
    link: `${API_BASE_URL}introduction/geographical-details/?administrative_unit=madhyapur_thimi`,
  },
  suryabinayak_municipality: {
    link: `${API_BASE_URL}introduction/geographical-details/?administrative_unit=suryabinayak`,
  },
}

const members_and_staffs = {
  'members': {
    'bhaktapur_ddc': API_BASE_URL + 'introduction/member/?administrative_unit=bhaktapur_district',
    'changunarayan_municipality': API_BASE_URL + 'introduction/member/?administrative_unit=changunarayan',
    'bhaktapur_municipality': API_BASE_URL + 'introduction/member/?administrative_unit=bhaktapur',
    'madhyapur_thimi_municipality': API_BASE_URL + 'introduction/member/?administrative_unit=madhyapur_thimi',
    'suryabinayak_municipality': API_BASE_URL + 'introduction/member/?administrative_unit=suryabinayak',
  },
  'staffs': {
    'bhaktapur_ddc': API_BASE_URL + 'introduction/employee/?administrative_unit=bhaktapur_district',
    'changunarayan_municipality': API_BASE_URL + 'introduction/employee/?administrative_unit=changunarayan',
    'bhaktapur_municipality': API_BASE_URL + 'introduction/employee/?administrative_unit=bhaktapur',
    'madhyapur_thimi_municipality': API_BASE_URL + 'introduction/employee/?administrative_unit=madhyapur_thimi',
    'suryabinayak_municipality': API_BASE_URL + 'introduction/employee/?administrative_unit=suryabinayak',
  }
}

const api_map_more_information = {
  'changunarayan_municipality': API_BASE_URL + 'introduction/more-info/?administrative_unit=changunarayan',
  'bhaktapur_municipality': API_BASE_URL + 'introduction/more-info/?administrative_unit=bhaktapur',
  'madhyapur_thimi_municipality': API_BASE_URL + 'introduction/more-info/?administrative_unit=madhyapur_thimi',
  'suryabinayak_municipality': API_BASE_URL + 'introduction/more-info/?administrative_unit=suryabinayak',
}

export default function LandingPage(props) {
  const classes = useStyles();
  const { ...rest } = props;

  const selectedMunicipality = props.match.params.municipality
  let selected_map_data = map_data.bhaktapur_ddc
  let selected_data = 'bhaktapur_ddc'
  if (selectedMunicipality === 'changunarayan') {
    selected_map_data = map_data.changunarayan_municipality
    selected_data = 'changunarayan_municipality'
  } else if (selectedMunicipality === 'bhaktapur') {
    selected_map_data = map_data.bhaktapur_municipality
    selected_data = 'bhaktapur_municipality'
  } else if (selectedMunicipality === 'madhyapur_thimi') {
    selected_map_data = map_data.madhyapur_thimi_municipality
    selected_data = 'madhyapur_thimi_municipality'
  } else if (selectedMunicipality === 'suryabinayak') {
    selected_map_data = map_data.suryabinayak_municipality
    selected_data = 'suryabinayak_municipality'
  }

  // React.useEffect(() => {
  //   window.scrollTo(0, 0)
  // });

  const [geographical_data, setGeographicalData] = React.useState(undefined);
  React.useEffect(() => {
    if (geographical_data === undefined) {
      fetch(api[selected_data].link)
        .then(results => results.json())
        .then(data => {
          setGeographicalData(data.results[0]);
        });
    }
  });

  const [more_information, setMoreInformation] = React.useState(undefined);
  React.useEffect(() => {
    if (more_information === undefined && selected_data !== 'bhaktapur_ddc') {
      fetch(api_map_more_information[selected_data])
        .then(results => results.json())
        .then(data => {
          setMoreInformation(data.results[0]);
        });
    }
  });

  const [member_list, setMemberList] = React.useState(undefined);
  React.useEffect(() => {
    if (member_list === undefined) {
      fetch(members_and_staffs['members'][selected_data])
        .then(results => results.json())
        .then(data => {
          setMemberList(data.results);
        });
    }
  });

  const [elected_member_list, setElectedMemberList] = React.useState(undefined);
  React.useEffect(() => {
    if (elected_member_list === undefined) {
      fetch(API_BASE_URL + 'introduction/elected-member/')
        .then(results => results.json())
        .then(data => {
          setElectedMemberList(data.results);
        });
    }
  });

  const [staff_list, setStaffList] = React.useState(undefined);
  React.useEffect(() => {
    if (staff_list === undefined) {
      fetch(members_and_staffs['staffs'][selected_data])
        .then(results => results.json())
        .then(data => {
          setStaffList(data.results);
        });
    }
  });



  return (
    <div>
      <Header
        color="primary"
        routes={dashboardRoutes}
        brand=<Brand />
        shrink_brand=<Brand shrink={true}/>
        rightLinks={<div><HeaderLinks /></div>}
        // fixed
        changeColorOnScroll={{
          // height: 70,
          // color: "primary",
        }}
        {...rest}
      />
      <div className={classNames(classes.main)}>
        <div style={{ backgroundColor: '#eee'}}>
          <div className={classes.container}>
            {selectedMunicipality === undefined && <Info info={district_info} link="intro" />}
            {selectedMunicipality === 'bhaktapur' && <Info info={info.bhaktapur} link="intro/bhaktapur" />}
            {selectedMunicipality === 'changunarayan' && <Info info={info.changunarayan} link="intro/changunarayan" />}
            {selectedMunicipality === 'madhyapur_thimi' && <Info info={info.madhyapur_thimi} link="intro/madhyapur_thimi" />}
            {selectedMunicipality === 'suryabinayak' && <Info info={info.suryabinayak} link="intro/suryabinayak" />}
          </div>
        </div>

        <div className={classes.container} >
          <Description
            data={selected_map_data}
            cultureAndHeritage={<CultureAndHeritage selected_data={selected_data}/>}
            map={<Map selectedMunicipality={selectedMunicipality}/>}
            detail_info={<GeographyInfo data={geographical_data}/>}
          />
        </div>

        {selected_data === 'bhaktapur_ddc' &&
        <div style={{ backgroundColor: '#eee' }}>
          <div className={classes.container} >
            <Municipality page="ddc_intro" />
          </div>
        </div>}

        {selected_data !== 'bhaktapur_ddc' && <div style={selected_data === 'bhaktapur_ddc' ? {}:{ backgroundColor: '#eee' }}>
          <div className={classes.container} >
            <WardList selected_data={selected_data}/>
          </div>
        </div>}

        <div>
          <div className={classes.container} >
            <OfficesList selected_data={selected_data}/>
          </div>
        </div>

        {selected_data === 'bhaktapur_ddc' && <div style={{ backgroundColor: '#eee' }}>
          <div className={classes.container} style={{textAlign: 'left !important'}}>
            <Staff data={priorityBasedSort(elected_member_list, 'method_of_election')} position_attrib='method_of_election' elected_representative={true} title="भक्तपुर जिल्लाबाट संघ र प्रदेशमा प्रतिनिधित्व गर्ने सांसदहरु"/>
          </div>
        </div>}

        {/*<div style={{ backgroundColor: '#eee' }}>
          <div className={classes.container} >
            <DescriptionOffices selected_data={selected_data}/>
          </div>
        </div>*/}

        {selected_data === 'bhaktapur_ddc' &&
        <div style={selected_data === 'bhaktapur_ddc' ? {}:{ backgroundColor: '#eee' }}>
          <div className={classes.container} >
            <DescriptionDistrict/>
          </div>
        </div>}

        <div style={{ backgroundColor: '#eee' }}>
          <div className={classes.container} >
            <Staff data={priorityBasedSort(member_list, 'member_designation')} position_attrib='member_designation' selection={selected_data} title={selected_data === 'bhaktapur_ddc' ? 'पदाधिकारीहरु' : member_data_map[selected_data].description+'का पदाधिकारीहरु'}/>
          </div>
        </div>

        {selected_data === 'bhaktapur_ddc' && <div style={selected_data === 'bhaktapur_ddc' ? {}:{ backgroundColor: '#eee' }}>
          <div className={classes.container} >
            <Staff data={priorityBasedSort(staff_list, 'employee_designation')} position_attrib='employee_designation' selection={selected_data} title="कर्मचारीहरु" />
          </div>
        </div>}

        <div style={selected_data === 'bhaktapur_ddc'?{ backgroundColor: '#eee' }:{}}>
          <div className={classes.container} >
            <ProjectAndBudget selection={selected_data}/>
          </div>
        </div>

        {selected_data === 'bhaktapur_ddc' &&
        <div style={{ backgroundColor: '#fff' }}>
          <div className={classes.container} >
            <Activities/>
          </div>
        </div>}

        {selected_data !== 'bhaktapur_ddc' &&
        <div style={{ backgroundColor: '#eee' }}>
          <div className={classes.container} >
            <MoreInformation data={more_information} selection={selected_data} title={selected_data === 'bhaktapur_ddc' ? 'थप जानकारी' : member_data_map[selected_data].description+'को कार्यालयका बारेमा थप जानकारी'}/>
          </div>
        </div>}

      </div>
      <Footer contact_info={<ContactInfo selection={selected_data}/>} />
    </div>
  );
}
